module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "reschedulingSenderCompletion"
    }
  }, [(!_vm.reschedulingInfo.isDenying) ? _c('section', {
    staticClass: "section"
  }, [_c('h1', {
    staticClass: "section-description"
  }, [_vm._v("授業振替が確定しました")]), _vm._v(" "), _c('h1', {
    staticClass: "section-description"
  }, [_vm._v(_vm._s(_vm.senderDisplayName) + "へご入力内容を通知するメールが届きます")])]) : _c('section', {
    staticClass: "section"
  }, [_c('h1', {
    staticClass: "section-description"
  }, [_vm._v("振替依頼を不承認し、他の振替候補日時を提案しました")]), _vm._v(" "), _c('h1', {
    staticClass: "section-description"
  }, [_vm._v(_vm._s(_vm.senderDisplayName) + "へご入力内容を通知するメールが届きます")])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5db4e41e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5db4e41e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ReschedulingPage/ReschedulingReceiverCompletion.vue
// module id = 725
// module chunks = 0